import type { JoinBannerData } from '@presentation/components/JoinBanner/types';

export interface JoinLandingPageData {
  joinBanner: JoinBannerData;
}

export interface JoinLandingPageProps extends JoinLandingPageData {}
